import {COUNTRIES_LIST} from "../Constants/CountriesList";

export const getCountryNameFromISO = (ISO: string) => {
  return COUNTRIES_LIST.find(country => country.ISO === ISO)?.Country;
};